import {Service, signal} from '@angular/core'
import {BehaviorSubject, ReplaySubject} from 'rxjs'
import {Insurances} from '../main/8-summary/summary.component'

@Service()
export class ControlService {

  public scenarioSelected$ = new BehaviorSubject<boolean>(false)

  /**
   * This is set to true if needed.
   */
  public declines = signal(false)

  /**
   * This is insurances, set informed to true if needed.
   */
  public insurances$ = new BehaviorSubject<Insurances>({
    informed: false, insurancesText: '', insurancesExtraText: '', insurancesTitle: ''
  })

  /**
   * To lock the customer from getting overwritten by another supervisor
   */
  public locked = signal(false)

  /**
   * We emit which step we should show.
   */
  public step$ = new ReplaySubject<number>(1)
  public canSave$ = new BehaviorSubject<boolean>(false)

  /**
   * Set a value or toggle the value
   *
   * @param declines - Set it to true or false or do not send it to toggle
   */
  public decline(declines: boolean): boolean {
    this.declines.set(declines)
    const step = this.declines() ? 7 : 1
    this.step$.next(step)
    return this.declines()
  }
}
